<div [loading]="loading()">
	@if(uBinders().length){
		<div class="carousel carousel-center w-full space-x-4">
		  @for(uBinder of uBinders(); track uBinder.ident){
			<div [id]="uBinder.ident" [ngClass]="{'element-show': fragment()==null}" class="carousel-item" [style.--i]="$index">
				<lgb-hero-binder [uBinder]="uBinder" [binder]="getBinder(uBinder)" route="collect-binder" [routeParams]="[uBinder.ident]"></lgb-hero-binder>
			</div>	
		  }
		</div>
	}
	@else{
		<img src="img/skin/empty-binder.svg"/>
		<div class="empty-container">
			<p class="subtitle">
				Aucun binder ouvert pour l’instant.<br/>
				Ouvre un binder pour commencer ta collection.
			</p>
			<a [routerLink]="router.get('collect-open-start')" class="btn btn-primary btn-gradient">Ajouter un binder</a>
		</div>
	}
</div>